import { render } from "./addModuleTemplate.vue?vue&type=template&id=491883c8"
import script from "./addModuleTemplate.vue?vue&type=script&lang=js"
export * from "./addModuleTemplate.vue?vue&type=script&lang=js"

import "./addModuleTemplate.vue?vue&type=style&index=0&id=491883c8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__